<div class="row" style="margin-right:0px;margin-left:0px;">
  <div class="offset-md-2 col-md-8 p-5 bg-apportis-secondary" style="margin-top: 5%">
    <div style="padding-bottom: 20px;">
      <nav class="navbar navbar-expand fixed-top px-3" style="padding:5px; box-shadow: 0 1px 1px 0px #ddd;">
        <a class="navbar-brand mr-auto" style="padding-top: 0.2rem; padding-bottom: .2rem;max-width:180px;height:54px;">
          <img src="./assets/apportis-new-logo.png" alt="logo-dark" style="max-width: 100%;max-height: 100%;">

        </a>

      </nav>
    </div>

    <div class="center text-center">
      <h1 class="display-1">It's Missing..!</h1>
      <h2 class="mb-5">404 Page Not Found</h2>
      <h4>Please re-check the URL and if you still feel something is wrong contact administrator</h4>
    </div>

  </div>
</div>